import React, { Suspense, lazy } from "react";
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactGA from 'react-ga4';

import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Lazy load components for code splitting
const Login = lazy(() => import("./components/Login"));
const Home = lazy(() => import("./components/Home"));
const Admin = lazy(() => import("./components/Admin"));

ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID || "G-VMS62E28PV");

function App(props) {

	const { user } = props;

	ReactGA.send({ hitType: "pageview", page: window.location.pathname });

	// useEffect(() => { 
	// 	ReactGA.send(window.location.pathname + window.location.search);
    // }, []);

	const LoadingFallback = () => (
		<div className="min-h-screen flex items-center justify-center">
			<div className="text-center">
				<div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
				<p className="mt-4 text-gray-600">Loading...</p>
			</div>
		</div>
	);

	return (
		<div className={`flex flex-col ${!user ? 'h-screen overflow-hidden' : 'min-h-screen'}`}>
			<Navbar />
			<Suspense fallback={<LoadingFallback />}>
			{
				!user ? (
					// User not logged in - Show Login/Registration page
					<Login />
				) : (
					// User logged in - Show profiles and routes
					<Switch>
						<Route exact path='/home' component={Home} />
						{user.role === "Admin" && (
							<Route exact path='/admin' component={Admin} />
						)}
						{/* Redirect any other route to /home for logged-in users */}
						<Redirect to="/home" />
					</Switch>
				)
			}
			</Suspense>
			{!user && <Footer />}
		</div>
	);
}

const mapStateToProps = state => ({
	user: state.user,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
